import React, { useEffect, useMemo, useRef, useState } from 'react';
import icon1 from '../../../../../assets/restaurant/images/color-icon1.png';
import icon2 from '../../../../../assets/restaurant/images/color-icon2.png';
import icon3 from '../../../../../assets/restaurant/images/color-icon3.png';
import {  todaySales } from '../../../services/tableOrder.service';
import { LOADER_TIMEOUT_TIME} from '../../../../../utils/Constants';
import { showPrice } from '../../../../../utils/commonfunction';
import { useTranslation } from 'react-i18next';
import SalesByDay from './salesByDay';
import SalesByMonth from './salesByMonth';
import SalesByweek from './salesByweek';
export default function RestDashboard() {

  const { t } = useTranslation();
  const [loader, setLoader] = useState(true);
  const [saleData, setSaleData] = useState(null);
  const [activeTab, setActiveTab] = useState("day");



  const getTodaySales = () => {
    setLoader(true);
    todaySales().then(response => {
      setSaleData(response.data)
    }).catch(error => {
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
      console.log("error ====> ", error);
    });
   
  }
  useEffect(() => {
    getTodaySales();
  }, []);

  // abc analysis part 



  return (
    <div className='home-dashboard'>
      <div className='container-fluid'>
        <div className='p-0'>
          <div className='dashboard-container'>
            <div className='dashboard-left'>
            <div className='inner-container'>
        <div className='d-flex tabs-with-etc justify-content-between align-items-center mb-4'>
        <ul className="nav nav-pills gap-3">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === t('restaurant.dashboard.day') ? t('restaurant.dashboard.active') : ""}`}
              onClick={() => setActiveTab(t('restaurant.dashboard.day'))}
            >
              {t("restaurant.dashboard.byDay")}
            </button>
          </li>

          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === t('restaurant.dashboard.month') ? t('restaurant.dashboard.active') : ""}`}
              onClick={() => setActiveTab(t('restaurant.dashboard.month'))}
            >
              {t("restaurant.dashboard.byMonth")}
            </button>
          </li>

          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === t('restaurant.dashboard.week') ? t('restaurant.dashboard.active') : ""}`}
              onClick={() => setActiveTab(t('restaurant.dashboard.week'))}
            >
              {t("restaurant.dashboard.byDayOfWeek")}
            </button>
          </li>
        </ul>
          {/* <div className='tabls-dowpdown'>
             <button className='btn btn-primary'>{t('restaurant.dashboard.Export')}</button>
          </div> */}
        </div>
        {activeTab === "day" && <SalesByDay />}
      {activeTab === "month" && <SalesByMonth />}
      {activeTab === "week" && <SalesByweek />}
      </div>


            </div>
            <div className='dashboard-right'>
              <div className='card rounded-0' style={{margin:'20px'}}>
                <div className='card-body'>
                  <div className='amount-block'>
                    <div className='amount-row'>
                      <figcaption>
                        <span>{t('restaurant.dashboard.amount_of_sale')}</span>
                        <h4>£ {showPrice(saleData?.totalSales || 0)}</h4>
                        <p>£ {showPrice(saleData?.totalSalesExcludingTax || 0)} {t('restaurant.dashboard.excluding_tax')}</p>
                      </figcaption>
                      <figure>
                        <img src={icon1} alt="Icon 1" />
                      </figure>
                    </div>
                    <div className='amount-row'>
                      <figcaption>
                        <span>{t('restaurant.dashboard.settled')}</span>
                        <h4>£ {showPrice(saleData?.settledOrders?.totalAmount || 0)}</h4>
                        <p>£ {showPrice(saleData?.settledOrders?.totalAmountExcludingTax || 0)} {t('restaurant.dashboard.excluding_tax')}</p>
                      </figcaption>
                      <figure>
                        <img src={icon2} alt="Icon 2" />
                      </figure>
                    </div>
                    <div className='amount-row'>
                      <figcaption>
                        <span>{t('restaurant.dashboard.unpaid')}</span>
                        <h4>£ {showPrice(saleData?.unsettledOrders?.totalAmount || 0)}</h4>
                        <p>£ {showPrice(saleData?.unsettledOrders?.totalAmountExcludingTax || 0)} {t('restaurant.dashboard.excluding_tax')}</p>
                      </figcaption>
                      <figure>
                        <img src={icon3} alt="Icon 3" />
                      </figure>
                    </div>
                  </div>
                </div>
                <hr className='m-0'></hr>
                <div className='card-body'>
                  <div className='user-statics'>
                   
                    <ul>
                      <li>
                        <h4>{t('restaurant.dashboard.number_of_transaction')}</h4>
                        <h4>{saleData?.totalTransactions || 0}</h4>
                      </li>
                      <li>
                        <h4>{t('restaurant.dashboard.settled')}</h4>
                        <h4>{saleData?.totalSettledTransactions || 0}</h4>
                      </li>
                      <li>
                        <h4>{t('restaurant.dashboard.unpaid')}</h4>
                        <h4>{saleData?.totalUnsettledTransactions || 0}</h4>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}
